import { PlusOutlined } from "@ant-design/icons"
import { Button, Skeleton } from "antd"
import React, { Suspense, lazy, useEffect, useState } from "react"

import { useAppSelector } from "../../../../../hooks/use-app-selector.ts"
import { SaveResultType } from "../../../redux/templates.types.ts"
import { type ProjectTypeAddPhaseFormData } from "../../../types/project-type.types.ts"

const ProjectTypeMilestoneAddModal = lazy(
  () => import("../ProjectTypeMilestoneAddModal")
)

interface ProjectTypeMilestonesFooterProps {
  saving?: boolean
  onAddPhase: (data: ProjectTypeAddPhaseFormData) => void
}

export function ProjectTypeMilestonesFooter({
  saving,
  onAddPhase
}: ProjectTypeMilestonesFooterProps) {
  const saveResult = useAppSelector((state) => state?.templates?.saveResult)

  const [showAdd, setShowAdd] = useState(false)

  const toggleShowAdd = () => setShowAdd(!showAdd)

  useEffect(() => {
    if (saveResult && saveResult.type === SaveResultType.PHASE_CREATE) {
      setShowAdd(false)
    }
  }, [saveResult])

  return (
    <div className={"px-2"}>
      {showAdd && (
        <Suspense
          fallback={
            <Skeleton.Node
              active
              className={"fixed w-lg z-10 h-96 inset-0 m-auto"}
            />
          }
        >
          <ProjectTypeMilestoneAddModal
            saving={saving}
            onSubmit={onAddPhase}
            onClose={toggleShowAdd}
          />
        </Suspense>
      )}

      <Button
        onClick={toggleShowAdd}
        className={"w-full"}
        size={"large"}
        icon={<PlusOutlined />}
      >
        Milestone
      </Button>
    </div>
  )
}
